{
  "add": "Ajouter",
  "edit": "Modifier",
  "delete": "Supprimer",
  "save": "Enregistrer",
  "cancel": "Annuler",
  "close": "Fermer",
  "confirm": "Confirmer",
  "done": "Terminé",
  "search": "Rechercher...",
  "searchPlaceholder": "Rechercher...",
  "filter": "Filtrer",
  "clear": "Effacer",
  "loading": "Chargement...",
  "error": "Erreur",
  "success": "Succès",
  "warning": "Avertissement",
  "info": "Info",
  "yes": "Oui",
  "no": "Non",
  "ok": "OK",
  "back": "Retour",
  "brandWordmark": "Homy",
  "backToHome": "Retour à HomyOS",
  "next": "Suivant",
  "previous": "Précédent",
  "submit": "Envoyer",
  "saving": "Enregistrement...",
  "change": "Modifier",
  "inactive": "Inactif",
  "reset": "Réinitialiser",
  "select": "Sélectionner",
  "selected": "Sélectionné",
  "all": "Tous",
  "none": "Aucun",
  "export": "Exporter",
  "general": "Général",
  "or": "ou",
  "actions": {
    "title": "Actions",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "edit": "Modifier",
    "delete": "Supprimer",
    "close": "Fermer",
    "confirm": "Confirmer",
    "back": "Retour",
    "next": "Suivant",
    "view": "Voir",
    "filter": "Filtrer",
    "reset": "Réinitialiser",
    "create": "Créer",
    "add": "Ajouter",
    "done": "Terminé",
    "submit": "Envoyer"
  },
  "state": {
    "loading": "Chargement...",
    "saving": "Enregistrement...",
    "submitting": "Envoi en cours...",
    "processing": "Traitement..."
  },
  "saveFailed": "Échec de l'enregistrement",
  "details": "Détails",
  "contextualHelp": {
    "trigger": "Aide et conseils",
    "openHelp": "Ouvrir l'aide",
    "closeHelp": "Fermer l'aide",
    "needMoreHelp": "Besoin d'aide ? Visitez le Centre d'aide"
  },
  "view": "Voir",
  "copy": "Copier",
  "copied": "Lien copié !",
  "clickToCopy": "Cliquer pour copier",
  "copyFailed": "Impossible de copier le lien",
  "share": "Partager",
  "toast": {
    "copyErrorDetails": "Copier les détails de l'erreur",
    "copied": "Copié"
  },
  "download": "Télécharger",
  "upload": "Téléverser",
  "remove": "Supprimer",
  "create": "Créer",
  "update": "Mettre à jour",
  "name": "Nom",
  "email": "E-mail",
  "phone": "Téléphone",
  "address": "Adresse",
  "date": "Date",
  "pickDate": "Choisir une date",
  "monthsShort": [
    "Janv",
    "Févr",
    "Mars",
    "Avr",
    "Mai",
    "Juin",
    "Juil",
    "Août",
    "Sept",
    "Oct",
    "Nov",
    "Déc"
  ],
  "time": "Heure",
  "status": {
    "title": "Statut",
    "active": "Actif",
    "inactive": "Inactif",
    "pending": "En attente",
    "draft": "Brouillon",
    "archived": "Archivé"
  },
  "type": "Type",
  "description": "Description",
  "required": "Requis",
  "optional": "Optionnel",
  "unassigned": "Non assigné",
  "nav": {
    "dashboard": "Tableau de bord",
    "inbox": "Boîte de réception",
    "listings": "Annonces",
    "properties": "Biens immobiliers",
    "visits": "Visites",
    "bookings": "Réservations",
    "availability": "Disponibilité",
    "eventTypes": "Types d'événements",
    "applications": "Candidatures",
    "rentals": "Locations",
    "pipelines": "Flux de travail",
    "workflows": "Flux de travail",
    "calendar": "Calendrier",
    "maintenance": "Maintenance",
    "vendorCockpit": "Tableau de bord",
    "maintenanceRequests": "Demandes",
    "projects": "Projets",
    "standingServices": "Services récurrents",
    "vendors": "Prestataires",
    "marketplace": "Place de marché",
    "vendorStatements": "Relevés",
    "support": "Support",
    "residentSupport": "Support",
    "orgSupport": "File de support",
    "helpCenter": "Centre d'aide",
    "tasks": "Tâches",
    "databases": "Bases de données",
    "organizations": "Organisation",
    "issues": "Signalements",
    "landingPage": "Page vitrine",
    "trust": "Confiance & Vérification",
    "settings": "Paramètres",
    "tenantLease": "Mon bail",
    "tenantPayments": "Paiements",
    "toggleGroup": "Basculer la section {{group}}",
    "openGroup": "Ouvrir le menu {{group}}",
    "mainNavigation": "Navigation principale",
    "group": {
      "portfolioMarketing": "Portefeuille & marketing",
      "leasing": "Gestion locative",
      "schedule": "Planning",
      "maintenance": "Maintenance",
      "workComms": "Opérations & communication",
      "dataOrg": "Données & organisation"
    },
    "documents": "Documents"
  },
  "organization": {
    "fallback": "Organisation",
    "manage": "Gérer l'organisation",
    "switch": "Changer d'organisation"
  },
  "viewAll": "Voir tout",
  "expandSidebar": "Développer le menu",
  "collapseSidebar": "Réduire la barre latérale",
  "collapse": "Réduire",
  "openMenu": "Ouvrir le menu",
  "toggleTheme": "Changer de thème",
  "theme": {
    "toggle": "Changer de thème",
    "light": "Clair",
    "dark": "Sombre",
    "system": "Système"
  },
  "changeLanguage": "Changer de langue",
  "morePages": "Plus de pages",
  "notifications": "Notifications",
  "platformConsole": "Console Plateforme",
  "userFallback": "Utilisateur HomyOS",
  "roleFallback": "Gestionnaire",
  "userMenu": {
    "openMenu": "Ouvrir le menu utilisateur",
    "profile": "Profil & préférences",
    "organization": "Organisation",
    "security": "Sécurité"
  },
  "logout": "Déconnexion",
  "visits": {
    "title": "Visites",
    "upcomingTitle": "Visites à venir",
    "upcomingVisits": "Visites à venir",
    "availability": "Disponibilité",
    "empty": "Aucune visite à venir.",
    "failedToLoad": "Impossible de charger les visites",
    "failedToUpdate": "Impossible de mettre à jour la visite",
    "property": "Bien immobilier",
    "date": "Date",
    "status": "Statut",
    "confirm": "Confirmer",
    "cancel": "Annuler la visite",
    "markNoShow": "Marquer comme absent",
    "visitor": "Visiteur",
    "configureAvailability": "Configurer",
    "sameHoursEveryDay": "Mêmes horaires tous les jours",
    "whichDays": "Quels jours ?",
    "whatHours": "Quelles heures ?",
    "to": "à",
    "howLongEachVisit": "Quelle est la durée de chaque visite ?",
    "slotsPerDay": "{{count}} créneaux/jour",
    "slotsPerWeek": "{{count}} créneaux/semaine",
    "minVisits": "Visites de {{count}} min",
    "noAvailability": "Aucune disponibilité configurée",
    "saveAvailability": "Enregistrer la disponibilité",
    "availabilitySaved": "Disponibilité enregistrée",
    "failedToSave": "Impossible d'enregistrer la disponibilité",
    "minuteAbbrev": "min",
    "yourSchedule": "Votre planning",
    "yourScheduleDescription": "Définissez votre disponibilité par défaut pour les visites",
    "perProperty": "Par bien",
    "usingDefault": "Utilisation de votre planning",
    "custom": "Personnalisé",
    "applyToAll": "Appliquer à tous",
    "applyToAllConfirm": "Cette action remplacera les disponibilités de tous les biens par votre planning général. Continuer ?",
    "saveSchedule": "Enregistrer le planning",
    "scheduleSaved": "Planning enregistré",
    "failedToSaveSchedule": "Impossible d'enregistrer le planning"
  },
  "errorBoundary": {
    "title": "Une erreur est survenue",
    "message": "Une erreur inattendue s'est produite. Veuillez rafraîchir la page ou revenir à la page d'accueil.",
    "refresh": "Rafraîchir la page",
    "goHome": "Retour à l'accueil"
  },
  "notFound": {
    "code": "Erreur 404",
    "title": "Page introuvable",
    "description": "La page que vous recherchez n'existe pas, a été supprimée ou a été déplacée vers une autre adresse.",
    "returnHome": "Retour au tableau de bord"
  },
  "apiError": {
    "default": "Une erreur est survenue. Veuillez réessayer.",
    "network": "Erreur réseau. Vérifiez votre connexion et réessayez."
  },
  "dataTable": {
    "rowsPerPage": "Par page",
    "showing": "Affichage de {{start}} à {{end}} sur {{total}}",
    "sortAscending": "Tri croissant",
    "sortDescending": "Tri décroissant",
    "clearSort": "Effacer le tri",
    "noResults": "Aucun résultat."
  },
  "list": {
    "filters": {
      "title": "Filtres",
      "active": "actifs",
      "clearAll": "Effacer les filtres",
      "removeFilter": "Supprimer {{filter}}",
      "dateRange": "Date Range",
      "selectDateRange": "Filter by date range"
    },
    "viewMode": {
      "label": "Mode d'affichage",
      "table": "Tableau",
      "thumbnails": "Cartes",
      "grid": "Grille",
      "list": "Liste",
      "map": "Carte",
      "kanban": "Tableau Kanban",
      "split": "Divisé"
    },
    "map": {
      "missingKeyTitle": "Carte indisponible",
      "missingKeyDescription": "Configurez VITE_GOOGLE_MAPS_API_KEY pour activer l'affichage de la carte.",
      "loadFailedTitle": "Échec du chargement de la carte",
      "loadFailedDescription": "Vérifiez votre connexion et réessayez.",
      "noLocationsTitle": "Aucun emplacement",
      "noLocationsDescription": "Aucun élément ne possède de coordonnées géographiques à afficher sur la carte."
    }
  },
  "profile": "Profil",
  "settings": "Paramètres",
  "approvals": {
    "title": "Approbations",
    "history": "Historique des approbations",
    "pending": "Approbations en attente",
    "noPending": "Aucune approbation en attente.",
    "noHistory": "Aucun historique d'approbation pour cet élément.",
    "status": {
      "PENDING": "En attente",
      "APPROVED": "Approuvé",
      "REJECTED": "Rejeté",
      "CANCELLED": "Annulé",
      "EXPIRED": "Expiré",
      "NEEDS_CLARIFICATION": "Précisions requises"
    },
    "strategy": {
      "SINGLE": "Approbateur unique",
      "ANY_OF": "N'importe quel approbateur",
      "ALL_OF": "Tous les approbateurs",
      "SEQUENTIAL": "Séquentiel"
    },
    "actions": {
      "approve": "Approuver",
      "reject": "Rejeter",
      "cancel": "Annuler la demande",
      "review": "Examiner",
      "submitting": "Envoi en cours..."
    },
    "dialog": {
      "approveTitle": "Approuver la demande",
      "rejectTitle": "Rejeter la demande",
      "cancelTitle": "Annuler la demande d'approbation",
      "notesLabel": "Notes d'examen",
      "notesPlaceholder": "Ajoutez vos commentaires ou justifications (optionnel)...",
      "reasonLabel": "Motif d'annulation",
      "reasonPlaceholder": "Expliquez pourquoi cette demande est annulée...",
      "confirmApprove": "Confirmer l'approbation",
      "confirmReject": "Confirmer le rejet",
      "confirmCancel": "Confirmer l'annulation"
    },
    "step": "Étape {{order}}",
    "requestedBy": "Demandé par",
    "assignedTo": "Attribué à",
    "resolvedBy": "Résolu par",
    "requestedAt": "Demandé le",
    "resolvedAt": "Résolu le",
    "notes": "Notes",
    "entityType": "Entité",
    "approvalType": "Type d'approbation",
    "request": "Request"
  },
  "unsavedChanges": {
    "title": "Abandonner les modifications ?",
    "description": "Les modifications non enregistrées seront perdues si vous fermez ce panneau.",
    "keepEditing": "Continuer à modifier",
    "discard": "Abandonner les modifications"
  },
  "security": {
    "restricted": "Restreint",
    "masked": {
      "restrictedValue": "••••••",
      "restrictedTooltip": "Données financières restreintes"
    },
    "lockedMetricTooltip": "Cet indicateur financier est restreint par la politique de l'organisation.",
    "unauthorized": {
      "title": "Accès restreint",
      "description": "Vous n'avez pas l'autorisation d'accéder à ce contenu."
    }
  },
  "retry": "Réessayer",
  "brandLogoAlt": "HomyOS",
  "brandOs": "OS",
  "clearSearch": "Effacer la recherche",
  "more": "Plus",
  "progress": "Progression",
  "created": "Créé",
  "statusLabel": "Statut",
  "id": "ID",
  "filters": {
    "primaryStateFilters": "Filtres d'état principaux"
  },
  "impersonation": {
    "activeAria": "Impersonation diagnostique active",
    "badgeTitle": "Impersonation diagnostique",
    "badge": "Impersonné",
    "viewingAs": "Affichage en tant que",
    "in": "dans",
    "readOnlyGuard": "Garde lecture seule active",
    "writeAllowed": "Écriture autorisée",
    "ttl": "30m TTL",
    "operator": "Opérateur :",
    "endSession": "Terminer la session de diagnostic",
    "exit": "Quitter l'impersonation"
  },
  "countryOptions": {
    "chile": "Chili (CLP / UF)",
    "argentina": "Argentine (ARS / USD)",
    "unitedStates": "États-Unis (USD)",
    "mexico": "Mexique (MXN)",
    "brazil": "Brésil (BRL)",
    "colombia": "Colombie (COP)",
    "spain": "Espagne (EUR)",
    "portugal": "Portugal (EUR)"
  },
  "landingPagePreview": "Aperçu de la page",
  "landingPagePreviewError": "Impossible de charger l'aperçu de la page",
  "views": {
    "switcher": "Changer la vue de l\"application",
    "operations": "Opérations",
    "resident": "Résident",
    "contractor": "Entrepreneur"
  },
  "call": "Call",
  "dateRangePicker": {
    "placeholder": "Select date range",
    "clear": "Clear date range",
    "presets": {
      "today": "Today",
      "last7": "Last 7 days",
      "last30": "Last 30 days",
      "mtd": "Month to date",
      "ytd": "Year to date"
    }
  },
  "fileDropzone": {
    "promptTitle": "Drag and drop file here",
    "promptSubtitle": "Supports PDF and images up to {{maxSizeMB}}MB",
    "browse": "Browse files",
    "uploading": "Uploading...",
    "ready": "Ready",
    "failed": "Failed",
    "preview": "Preview",
    "download": "Download",
    "remove": "Remove file",
    "close": "Close",
    "empty": "No files attached yet",
    "previewUnavailable": "Inline preview is not available for this file."
  },
  "notificationPopover": {
    "title": "Notifications",
    "markAllRead": "Mark all read",
    "markRead": "Mark as read",
    "all": "All",
    "unread": "Unread",
    "emptyTitle": "All caught up",
    "emptyUnread": "No unread notifications",
    "emptyAll": "No recent notifications",
    "viewAll": "View all in Operations Inbox"
  },
  "auditTimeline": {
    "today": "Today",
    "yesterday": "Yesterday",
    "activity": "Audit Log",
    "eventSingular": "{{count}} event",
    "eventPlural": "{{count}} events",
    "emptyTitle": "No audit events recorded",
    "emptySubtitle": "Audit milestones and events will appear here."
  },
  "editableCell": {
    "save": "Save (Enter)",
    "cancel": "Cancel (Esc)",
    "invalidValue": "Invalid value",
    "saveError": "Failed to save",
    "selectPlaceholder": "Select..."
  }
}
